import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import { useBag } from '../../contexts/BagContext';
import { useLanguage } from '../../contexts/LanguageContext';
import logo from '../../assets/logo.jpg';
import './Header.css';

const Header: React.FC = () => {
  const { t } = useTranslation();
  const { language, setLanguage } = useLanguage();
  const { user, isAuthenticated, logout } = useAuth();
  const { getBagCount } = useBag();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/');
    setMenuOpen(false);
  };

  const toggleLanguage = () => {
    const newLang = language === 'en' ? 'ar' : 'en';
    setLanguage(newLang);
  };

  const bagCount = getBagCount();

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="logo">
          <img src={logo} alt="21 Minutes" className="logo-image" />
        </Link>

        <nav className={`nav ${menuOpen ? 'nav-open' : ''}`}>
          <Link to="/" className="nav-link" onClick={() => setMenuOpen(false)}>
            {t('nav.home')}
          </Link>
          <Link to="/products" className="nav-link" onClick={() => setMenuOpen(false)}>
            {t('nav.products')}
          </Link>
          {isAuthenticated && (
            <Link to="/orders" className="nav-link" onClick={() => setMenuOpen(false)}>
              {t('nav.orders')}
            </Link>
          )}
        </nav>

        <div className="header-actions">
          <button onClick={toggleLanguage} className="language-toggle" aria-label="Toggle language">
            {language === 'en' ? 'ع' : 'EN'}
          </button>

          <Link to="/cart" className="cart-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="9" cy="21" r="1" />
              <circle cx="20" cy="21" r="1" />
              <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
            </svg>
            {bagCount > 0 && <span className="cart-badge">{bagCount}</span>}
          </Link>

          {user ? (
            <div className="user-menu">
              <button className="user-button" onClick={() => setMenuOpen(!menuOpen)}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                  <circle cx="12" cy="7" r="4" />
                </svg>
              </button>
              {menuOpen && (
                <div className="dropdown-menu">
                  <div className="user-info">
                    <p className="user-name">{user.name}</p>
                    {user.phone && <p className="user-phone">{user.phone}</p>}
                  </div>
                  <button className="dropdown-item" onClick={handleLogout}>
                    {t('nav.logout')}
                  </button>
                </div>
              )}
            </div>
          ) : (
            <Link to="/login" className="btn-login">
              {t('nav.login')}
            </Link>
          )}

          <button
            className="hamburger"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
